/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { motion } from "framer-motion";
import { useMemo, useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useAuth } from "@/services/userService";
import { useGetForumsGroups } from "@/services/forumGroupService";
import { Link } from "@/router";
import { VERSION } from "@/utils/version";
import { Users, Crown, Hammer, CalendarClock, Speech, Settings2, Group, DatabaseBackup, ArrowUpDownIcon } from "lucide-react";
import { bgColors500 } from "@/utils/stringToTailwindClass";

export default function SideBar(props) {

    const location = useLocation()
    const { auth  } = useAuth()
    const getForumsGroups = useGetForumsGroups()
    const [groups, setGroups] = useState([])

    const rights = useMemo(() => {
        let rights = []
        auth.user?.roles?.forEach((role) => {
            rights.push(...role.rights)
        })
        rights = rights.filter((item) => !Object.prototype.hasOwnProperty.call(rights, item))

        return rights
    }, [auth.user])



    const isAdmin = useMemo(() => {
        return rights.filter((v) => v.includes("_admin")).length > 0;
    }, [rights]);

    const hasRight = useCallback(
        (right) => {
        return rights.includes(right);
        },
        [rights]
    );

    const isLoggedIn = useMemo(() => {
        return auth.isAuthenticated
    }, [auth.isAuthenticated])



    const showSideBar = useMemo(() => {
        return props.menuOpen;
    }, [props.menuOpen]);

    useEffect(() => {
        const getGroups = async () => {
            const groups = await getForumsGroups()
            setGroups(groups)
        }

        if (auth.isAuthenticated && hasRight('forums_access')) {
            getGroups()
        }

    }, [auth.isAuthenticated, rights])

    return !isLoggedIn ? null : (
        <motion.aside
        initial={{ width: 256 }}
        animate={{ width: showSideBar ? 256 : 0 }}
        transition={{ type: "tween", duration: 0.3 }}
        className={`fixed md:relative bg-gray-100 shadow-lg h-full md:w-64 flex flex-col justify-between
                    ${showSideBar ? "w-64 z-40 md:z-20" : "w-0 md:w-64"}
                    ${showSideBar ? "top-0 left-0 md:left-auto" : "-left-64 md:left-0"}
                    
                `}
            >
                { showSideBar && (
                    <>
                        <div className="pt-4">
                            <h2 className="px-6 text-primary text-lg my-4 cursor-pointer  hover:bg-gray-300" lang="fr">
                                Espace personnel
                            </h2>
                            <ul>
                                <Link to="/profile">
                                    <li className="px-6 text-secondary text-base mb-1 cursor-pointer hover:bg-gray-300" lang="fr">
                                    Mon profil
                                    </li>
                                </Link>
                                {hasRight('whoiswho_access') && (
                                    <Link to="/whoiswho">
                                        <li className="px-6 text-secondary text-base mb-1 cursor-pointer hover:bg-gray-300" lang="fr">
                                        Who is Who
                                        </li>
                                    </Link>
                                )}
                            </ul>

                        {hasRight('forums_access') && (
                            <>
                                <h2 className="px-6 text-primary text-lg my-4 cursor-pointerhover:bg-gray-300" lang="fr">
                                    Catégories
                                </h2>
                                <ul className="">
                                        {groups && groups.filter((group) => group.sidebar_category).sort((a, b) => a.name.localeCompare(b.name)).map((group, i) => {
                                            return (
                                                <Link key={i} to={`/forums?group_id=${group.id}`} lang="fr" title={group.name}>
                                                    <li className="px-6 text-secondary text-base py-1 mb-1 cursor-pointer hover:bg-gray-300 flex flex-row flex-nowrap items-center gap-1">
                                                        <div className={`h-2 w-2 ${bgColors500[group.color]}`} />
                                                        <span className="whitespace-nowrap text-ellipsis overflow-hidden text-sm">{group.name}</span>
                                                    </li>
                                                </Link>
                                            )
                                        })}
                                        <Link to="/forums/" lang="fr">
                                            <li className="px-6 text-secondary text-base py-1 mb-1 cursor-pointer hover:bg-gray-300">
                                            Tous les forums
                                            </li>
                                        </Link>
                                </ul>
                            </>
                        )}
                        {/* Si connecté en tant qu'admin, afficher le menu */}
                        { isAdmin && (
                            <>
                                <h2 className="px-6 text-primary text-lg my-4 cursor-pointer  hover:bg-gray-300 flex flex-row items-center gap-1" lang="fr">
                                    <Settings2 size={16} /><span>Administration</span>
                                </h2>
                                <ul>
                                    {hasRight('users_admin') && (
                                        <Link to="/admin/users">
                                            <li className="px-6 text-secondary text-base py-1 mb-1 cursor-pointer hover:bg-gray-300 flex flex-row items-center gap-1" lang="fr">
                                                <Users size={16} /><span>Gestion des utilisateurs</span>
                                            </li>
                                        </Link>
                                    )}
                                    {hasRight('roles_admin') && (
                                        <Link to="/admin/roles" className="w-full">
                                            <li className="px-6 text-secondary text-base py-1 mb-1 cursor-pointer hover:bg-gray-300 flex flex-row items-center gap-1" lang="fr">
                                                <Crown size={16} /><span>Gestion des roles</span>
                                            </li>
                                        </Link>
                                    )}
                                    {hasRight("skills_admin") && (
                                        <Link to="/admin/skills" className="w-full">
                                            <li className="px-6 text-secondary text-base py-1 mb-1 cursor-pointer hover:bg-gray-300 flex flex-row items-center gap-1" lang="fr">
                                                <Hammer size={16} /><span>Gestion des métiers</span>
                                            </li>
                                        </Link>
                                    )}
                                    {hasRight("competitions_admin") && (
                                        <Link to="/admin/competitions" className="w-full">
                                            <li className="px-6 text-secondary text-base py-1 mb-1 cursor-pointer hover:bg-gray-300 flex flex-row items-center gap-1" lang="fr">
                                                <CalendarClock size={16} /><span>Gestion des compétitions</span>
                                            </li>
                                        </Link>
                                    )}
                                    {hasRight("forums_admin") && (
                                        <Link to="/admin/forums" className="w-full">
                                            <li className="px-6 text-secondary text-base py-1 mb-1 cursor-pointer hover:bg-gray-300 flex flex-row items-center gap-1" lang="fr">
                                                <Speech size={16} /><span>Gestion des forums</span>
                                            </li>
                                        </Link>
                                    )}
                                    {hasRight("forum_groups_admin") && (
                                        <Link to="/admin/forum_groups" className="w-full">
                                            <li className="px-6 text-secondary text-base py-1 mb-1 cursor-pointer hover:bg-gray-300 flex flex-row items-center gap-1" lang="fr">
                                                <Group size={16} /><span>Groupes de forums</span>
                                            </li>
                                        </Link>
                                    )}
                                    {hasRight("backups_admin") && (
                                        <Link to="/admin/backup" className="w-full">
                                            <li className="px-6 text-secondary text-base py-1 mb-1 cursor-pointer hover:bg-gray-300 flex flex-row items-center gap-1" lang="fr">
                                                <DatabaseBackup size={16} /><span>Backup / Restore</span>
                                            </li>
                                        </Link>
                                    )}
                                    {hasRight("users_admin") && (
                                        <Link to="/admin/imports/users" className="w-full">
                                            <li className="px-6 text-secondary text-base py-1 mb-1 cursor-pointer hover:bg-gray-300 flex flex-row items-center gap-1" lang="fr">
                                                <ArrowUpDownIcon size={16} /><span>Imports / Exports</span>
                                            </li>
                                        </Link>
                                    )}
                                </ul>
                            </>
                        )}

                        {/* Afficher le lien vers la charte d'utilisation */}
                        <div className="w-full text-center text-blue-500 text-base flex flex-col place-items-center justify-center gap-1 mt-5" lang="fr">
                            <Link to={location.pathname} className="hover:text-blue-800" lang="fr" state={ {modal: "/charte-utilisation"} }>
                                Charte d&apos;utilisation
                            </Link>
                            <Link to={location.pathname} className="hover:text-blue-800" lang="fr" state={ {modal: "/politique-confidentialite"} }>
                                Politique de confidentialité
                            </Link>
                        </div>

                        </div>
                        <div className="text-center text-gray-400 text-sm mb-4" lang="fr">
                            Version : {VERSION || "-"}
                        </div>
                    </>
                ) }

            
        </motion.aside>
    );


}
